<template>
  <transition
    enter-active-class="transition-opacity"
    leave-active-class="transition-opacity"
    enter-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div class="chatbot-widget" :class="{'logged-in': isSessionUserKnown}">
      <div class="chatbot-widget__fixed chatbot-widget__header">
        <div class="chatbot-widget__header__left">
          <img v-if="hasChatIcon" class="chatbot-widget__header__left__icon" :src="getChatIcon">
          <span>{{campaign.display_name}} Chat</span>
        </div>
        <div class="close-icon" @click.stop="$emit('close')">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M13.5 13.5L1.5 1.5M13.5 1.5L1.5 13.5" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="chatbot-widget__body" ref="messagesContainer">
        <div
          v-for="(message, index) in messages"
          :key="index"
          class="chat-message"
          :class="{ 'user-message': message.isUser }"
        >
          <img v-if="!message.isUser" class="logo" :src="getChatIcon" />
          <div class="d-flex flex-column">
            <span class="message-text" v-html="message.text"></span>
            <span v-if="message.time" class="message-time">{{message.time}}</span>
          </div>
        </div>

        <div class="chat-message loader-message" v-if="processing">
          <img class="logo" :src="getChatIcon" />
          <div class="d-flex flex-column">
            <span class="message-text">
              <svg xmlns="http://www.w3.org/2000/svg" width="29" height="20" viewBox="0 0 29 10">
                <circle class="dot" cx="4.5" cy="5.5" r="2.5" fill="#5A5A5A"/>
                <circle class="dot" cx="14.5" cy="4.5" r="2.5" fill="#5A5A5A"/>
                <circle class="dot" cx="24.5" cy="5.5" r="2.5" fill="#5A5A5A"/>
              </svg>
            </span>
          </div>

        </div>
      </div>
      <div class="chatbot-widget__fixed chatbot-widget__footer">
        <b-form-textarea
          ref="textInput"
          v-model="currentMessage"
          class="form-control message-input"
          placeholder="Start typing your message..."
          @keypress.enter.exact="sendMessage()"
        />
        <div class="send-icon" @click.stop="sendMessage()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M10.6791 10.6642L4.40244 11.71C4.33028 11.722 4.26256 11.7529 4.2061 11.7994C4.14963 11.8459 4.10641 11.9065 4.08078 11.975L1.91661 17.7733C1.70994 18.3067 2.26744 18.815 2.77911 18.5583L17.7791 11.0583C17.8828 11.0064 17.97 10.9266 18.0309 10.8279C18.0918 10.7292 18.1241 10.6156 18.1241 10.4996C18.1241 10.3836 18.0918 10.2699 18.0309 10.1713C17.97 10.0726 17.8828 9.9928 17.7791 9.94084L2.77911 2.44083C2.26744 2.185 1.70994 2.69333 1.91661 3.22583L4.08161 9.02417C4.10724 9.09269 4.15047 9.15326 4.20693 9.19978C4.2634 9.24629 4.33112 9.27712 4.40328 9.28917L10.6799 10.335C10.7191 10.3413 10.7547 10.3613 10.7805 10.3914C10.8062 10.4216 10.8203 10.4599 10.8203 10.4996C10.8203 10.5392 10.8062 10.5776 10.7805 10.6077C10.7547 10.6379 10.7191 10.6579 10.6799 10.6642"/>
          </svg>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
import {mapGetters, mapState} from 'vuex'
import AuthToken from '@/components/AuthToken'
import {dateDifference} from '@/utils'
import authToken from '@/components/AuthToken.vue'

export default {
  components: {AuthToken},
  computed: {
    ...mapState(['session', 'campaign', 'token']),
    ...mapGetters(['isSessionUserKnown']),
    hasChatIcon: function() {
      return this.campaign && this.campaign.chatbot_icon
    },
    getChatIcon: function() {
      if (this.hasChatIcon) {
        return this.campaign.chatbot_icon.file
      }
      return null
    }
  },
  data() {
    return {
      messages: [{
        text: "Hi there! How may I help you?", // Initial greeting message
        sentAt: new Date(),
        isUser: false,
      }],
      currentMessage: null,
      processing: false,
      $timeInterval: null
    };
  },
  methods: {
    sendMessage() {
      if (this.currentMessage.trim() === "") return;
      this.processing = true
      const userMessage = {
        isUser: true,
        time: '0m ago',
        sentAt: new Date(),
        text: this.currentMessage
      }

      this.messages.push(userMessage);
      setTimeout(() => {
        this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
        this.currentMessage = null
      }, 100)
      const url = (process.env.VUE_APP_CHAT_BOT_URL || 'http://localhost:4200/') + 'v1/chats'

      fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify({
          "parent_session_id": this.session.parent_session_id || this.session.id,
          "session_id": this.session.id,
          "campaign_id": this.campaign.id,
          "account_id": this.campaign.account_id,
          "question": this.messages[this.messages.length - 1].text
        })
      }).then(async (response) => {
        if (response.ok) {
          this.processing = false
          const index = this.messages.length
          const reader = response.body.getReader()

          while (true) {
            const { done, value } = await reader.read()
            if (value && value.length > 0) {
              for(let i = 0; i < value.length; i++) {
                let newMessage = ""
                if (value[i] === 10) {
                  newMessage += '</p><p>'
                } else {
                  newMessage +=  String.fromCharCode.apply(null, [value[i]])
                }

                if (this.messages[index]) {
                  this.messages[index].text += newMessage
                } else {
                  this.messages.push({
                    isUser: false,
                    time: '0m ago',
                    sentAt: new Date(),
                    text: '<p>' + newMessage
                  })
                }
                this.messages[index].text = this.messages[index].text
                  .replaceAll('#$#', '')
                  .replaceAll(/ MESSAGE_ID:[0-9]\d+ /gm, '')
                  .replaceAll('{brand}.solvpath.com', window.location.host)
                setTimeout(() => {
                  this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
                }, 100)
              }
            }
            if (done) {
              this.messages[index].text += '</p>'
              return;
            }
          }
        } else {
          if (response.status === 401) {  // user token is invalid
            this.$store.commit('logout')
          } else {
            this.messages.push({
              isUser: false,
              time: '0m ago',
              sentAt: new Date(),
              text: "Sorry, we are unable to understand your query. Please try again",
            })
          }
        }
      }).catch((error)=> console.error(error))
        .finally(() => {
          this.processing = false
          localStorage.setItem('chat', JSON.stringify(this.messages))
          setTimeout(() => {
            this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
          }, 100)
        })
    },
    calculateTime: function() {
      this.messages.forEach((message, index) => {
        if (index !== this.messages.length - 1 && this.messages[index].isUser === this.messages[index + 1].isUser) {
          this.messages[index].time = null
          this.messages[index].sentAt = null
        }
        if (message.sentAt) {
          const {diffInMinutes, diffInHours} = dateDifference(message.sentAt, new Date())
          if (diffInHours > 0) {
            message.time = `${diffInHours}h ago`
          } else {
            message.time = `${diffInMinutes}m ago`
          }
        }
      })
    }
  },
  beforeDestroy() {
    if (this.$timeInterval) {
      clearInterval(this.$timeInterval)
      this.$timeInterval = null
    }
  },
  created() {
    const messages = localStorage.getItem('chat')
    if (messages) {
      this.messages = JSON.parse(messages)
      if (this.$refs && this.$refs.messagesContainer) {
        setTimeout(() => {
          this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
        }, 100)
      }
    }
    this.calculateTime()
    this.$timeInterval = setInterval(() => this.calculateTime(), 60000)
  }
};
</script>

<style scoped lang="less">

  @keyframes typing {
    0% {
      opacity: 0.2;
      transform: translateY(0);
    }
    50% {
      opacity: 1;
      transform: translateY(-5px);
    }
    100% {
      opacity: 0.2;
      transform: translateY(0);
    }
  }

  .dot {
    animation: typing 1s infinite;
  }

  .dot:nth-child(1) {
    animation-delay: 0s;
  }

  .dot:nth-child(2) {
    animation-delay: 0.2s;
  }

  .dot:nth-child(3) {
    animation-delay: 0.4s;
  }

  .chat-message {
    gap: 5px;
    margin-bottom: 5px;
    display: inline-flex;
    align-items: flex-end;

    &.loader-message {
      margin-bottom: 20px;
    }

    .message-text {
      max-width: 231px;
      padding: 10px;
      overflow: hidden;
      white-space: pre-wrap;
      border-radius: 10px;
      color: #163549;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
      font-family: var(--font_family);
      background: #EFEFEF;
      word-wrap: break-word;

      > p:last-child {
        margin-bottom: 0;
      }
    }

    .message-time {
      color: #A39C9C;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-top: 5px;
      margin-bottom: 15px;
    }

    .logo {
      width: 40px;
      height: 40px;
      padding: 5px;
      border-radius: 50px;
      align-self: flex-start;
      background: #EFEFEF;
      border: 1px solid #E6E6E6;
    }

    &.user-message {
      align-self: flex-end;
      .message-text {
        background-color: var(--theme_color);
        color: #FFFFFF;
        align-self: flex-end;
      }

      .message-time {
        text-align: right;
      }
    }
  }

  .visible {
      top: auto;
}

  .opacity-0 {
    opacity: 0;
  }

  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
  }

  .close-icon {
    display: flex;
    width: 35px;
    height: 35px;
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 40px;
    cursor: pointer;
    background: rgba(var(--theme_color), 0.10);
  }

  .chatbot-widget {
    z-index: 1;
    display: flex;
    position: fixed;
    overflow: hidden;
    flex-direction: column;
    background-color: #FFFFFF;
    bottom: 0;
    left: 0;
    right: 0;
    top: 108px;

    @media only screen and (min-width: 575px) {
      border-radius: 20px;
      bottom: 145px;
      left: calc(100vw - 395px);
      top: unset;
      right: 0;
      width: 375px;
      height: 550px;
      flex-shrink: 0;
      box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.05);

    }
    &.logged-in {
      @media only screen and (min-width: 575px) {
        bottom: 170px;
      }
    }

    &__fixed {
      left: 0;
      right: 0;
      width: 100%;
      padding: 20px;
      position: fixed;

      @media only screen and (min-width: 575px) {
        left: calc(100vw - 395px);
        width: 375px;
      }
    }

    &__header {
      height: 75px;
      display: flex;
      flex-shrink: 0;
      padding: 15px;
      align-items: center;
      justify-content: space-between;
      color: #FFFFFF;
      z-index: 3;
      background: var(--theme_color);

      @media only screen and (min-width: 360px) {
        padding: 15px 20px;
      }

      @media only screen and (min-width: 575px) {
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
      }

      &__left {
        display: flex;
        align-items: center;
        gap: 15px;
        flex: 1 0 0;
        color: #FFFFFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;

        &__icon {
          width: 52px;
          height: 52px;
          background: #FFFFFF;
          border-radius: 50px;
          padding: 8px;
          object-fit: contain;
        }
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      justify-content: safe flex-end;
      padding: 20px 20px 0;
      background: #FFFFFF;
      flex: 1 1 100%;
      position: absolute;
      top: 75px;
      left: 0;
      right: 0;
      overflow-y: auto;
      height: calc(100% - 95px - 51px);
    }

    &__footer {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      background: #FFFFFF;
      z-index: 2;
      padding-top: 0;

      @media only screen and (min-width: 575px) {
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px;
      }

      > div {
        display: flex;
        padding: 20px;
        position: fixed;
      }

      .message-input {
        display: flex;
        width: 100%;
        padding: 15px 45px 15px 15px;
        justify-content: space-between;
        align-items: center;
        border-radius: 10px;
        border: 1px solid #E6E6E6;
        background: #FAFAFA;
        color: #A39C9C;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px; /* 150% */
        height: 51px !important;
        resize: none;
      }

      .send-icon {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        position: absolute;
        right: 36px;
        top: 16px;
        z-index: 2;
        padding: 0;
        cursor: pointer;

        svg {
          path {
            fill: var(--theme_color);
          }
        }
      }
    }
  }
</style>
